/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { addCropData, copyCrop, createQuotation, deleteCropById, editCropData, getCropById, getCropData, getCropDatawithBillStatus, getSchedulesByCropId } from "../api/api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Loading from "../components/Loading";
import { FaFileInvoice, FaEdit, FaTrash } from "react-icons/fa";
import bannerImg from "../assets/banner.jpg";
import leaf from "../assets/Greenleaf.png";
import { useRef } from "react";
import { FaCopy } from "react-icons/fa";
import { motion } from "framer-motion";
import { syncQuotationToGoogleCalendar } from "../utils/googleCalendar";
import { useAuth } from "../context/AuthContext";

function CropList() {
  const [cropList, setCropList] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isCopyDialogOpen, setIsCopyDialogOpen] = useState(false);
  const [newCrop, setNewCrop] = useState({ name: "", description: "", weeks: "" });
  const [editCropId, setEditCropId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [acreValues, setAcreValues] = useState({});

  const navigate = useNavigate();
  const { auth } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [selectedScheduleId, setSelectedScheduleId] = useState(false);
  const [selectedCropId, setSelectedCropId] = useState("");
  const [farmerInfo, setFarmerInfo] = useState({
    name: "",
    place: "",
    tahsil: "",
    district: "",
    state: "",
  });
  const [searchTerm, setSearchTerm] = useState("");

  const modalRef = useRef(null);

  // Fetch crops
  useEffect(() => {
    setLoading(true);
    fetchCrops();
  }, []);

  const fetchCrops = async () => {
    try {
      setLoading(true);

      const res = await getCropDatawithBillStatus();
      setCropList(res || []);
    } catch (err) {
      console.log(err);

      toast.warning("Unable to fetch Data!");
      setCropList([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle create/update
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newCrop.weeks <= 0) {
      toast.warning("ॲप्लिकेशन संख्या 0 किंवा त्यापेक्षा कमी असू शकत नाही!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
        // transition: Bounce,
      });
      return;
    }

    if (editCropId) {
      const res = await editCropData(editCropId, newCrop);
    } else {
      const res = await addCropData(newCrop);
    }
    fetchCrops();
    setIsDialogOpen(false);
    setNewCrop({ name: "", weeks: "", description: "" });
    setEditCropId(null);
  };

  // Handle edit
  const handleEdit = (crop) => {
    setNewCrop({ name: crop.name, weeks: crop.weeks, description: crop.description });
    setEditCropId(crop._id);
    setIsDialogOpen(true);
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: "Confirm to delete",
      message: "आपणास हा पिक खरोखर हटवायचा आहे का? / Do you really want to delete this crop?",

      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const toastId = toast.loading("Deleting crop...");

            try {
              await deleteCropById(id);
              fetchCrops();

              toast.update(toastId, {
                render: "Crop deleted successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
                position: "top-center",
              });
            } catch (error) {
              toast.error(toastId, {
                render: "Failed to delete crop",
                type: "error",
                isLoading: false,
                autoClose: 3000,
                position: "top-center",
              });
            }
          },
        },
        {
          label: "No",
          onClick: () => {
            // Do nothing
          },
        },
      ],
    });
  };

  const handleSubmitCopyCrop = async (e) => {
    e.preventDefault();
    try {
      if (!selectedCropId) {
        toast.error("No crop selected to copy");
        return;
      }

      const payload = {
        name: newCrop.name,
        description: newCrop.description,
        weeks: newCrop.weeks,
        weekInterval: newCrop.weekInterval,
      };

      const res = await copyCrop(selectedCropId, payload);
      toast.success(`Crop copied successfully: ${res.newCrop.name}`);
      setIsCopyDialogOpen(false);
      fetchCrops();
      setNewCrop({ name: "", description: "", weeks: "", weekInterval: "" });
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to copy crop");
    }
  };

  const handleCopyCrop = async (id) => {
    setIsCopyDialogOpen(true);
    setSelectedCropId(id);
    // try {
    //   // console.log("res._id ",res._id);

    //   // const res = await getCropById(id);
    //   const res = await getSchedulesByCropId(id);
    //   if (res) {
    //     console.log("res ", res);
    //   }
    // } catch (error) {
    //   toast.error(error?.response?.data?.message || "Failed to get crop");
    // }
  };

  // handleSubmit()

  const handleGenerateQuotation = async (cropId, farmerData) => {
    setLoading(true);
    try {
      const loggedInUser = JSON.parse(sessionStorage.getItem("user"));

      const updatedFarmerData = {
        ...farmerInfo,
        _id: loggedInUser?._id || farmerInfo?._id || "",
        email: farmerInfo?.email || loggedInUser?.email || "",
        number: farmerInfo?.number || loggedInUser?.number || "",
      };

      const crop = await getCropById(cropId);
      const schedule = await getSchedulesByCropId(cropId);

      const acreValue = acreValues[cropId];
      const acres = Number(acreValue);
      const allProducts = (schedule.weeks || []).flatMap((week) => week.products || []);

      const newStartDate = farmerData.startDate ? new Date(farmerData.startDate) : null;

      let dateDiffs = [];
      if (schedule.weeks.length > 1) {
        for (let i = 1; i < schedule.weeks.length; i++) {
          const prev = new Date(schedule.weeks[i - 1].date);
          const curr = new Date(schedule.weeks[i].date);
          const diffDays = Math.round((curr - prev) / (1000 * 60 * 60 * 24));
          dateDiffs.push(diffDays);
        }
      }

      const updatedWeeks = schedule.weeks.map((week, index) => {
        let newWeekDate;

        if (newStartDate) {
          if (index === 0) {
            newWeekDate = new Date(newStartDate);
          } else {
            const daysToAdd = dateDiffs.slice(0, index).reduce((sum, d) => sum + d, 0);
            newWeekDate = new Date(newStartDate);
            newWeekDate.setDate(newStartDate.getDate() + daysToAdd);
          }
        } else {
          newWeekDate = new Date(week.date);
        }

        return {
          ...week,
          date: newWeekDate.toISOString().split("T")[0],
          totalWater: Number(acres * Number(week.waterPerAcre || 0)).toFixed(2),
          totalAcres: String(acres),
          productAmountMg: String(acres * Number(week.productAmountMg || 0)),
          productAmountLtr: String(acres * Number(week.productAmountLtr || 0)),
          products: (week.products || []).map((prod) => {
            const [mlPart, lPart] = (prod.quantity || "").split("&").map((q) => q.trim());
            const ml = parseFloat(mlPart?.split(" ")[0]) || 0;
            const mlUnit = mlPart?.split(" ")[1] || "ml/grm";
            const l = parseFloat(lPart?.split(" ")[0]) || 0;
            const lUnit = lPart?.split(" ")[1] || "ltr/kg";
            const repeatCount = allProducts.filter((p) => p.name === prod.name).length;

            return {
              name: prod.name,
              quantity: `${(ml * acres).toFixed(2)} ${mlUnit} & ${(l * acres).toFixed(3)} ${lUnit}`,
              perLitreMix: prod.perLitreMix,
              price: Number(prod.pricePerAcre * acres * repeatCount).toFixed(2),
              instruction: prod.instruction,
              category: prod.category,
              rate: prod.rate,
            };
          }),
        };
      });

      const quotationPayload = {
        cropId,
        cropName: crop.name,
        acres,
        weeks: updatedWeeks,
        farmerInfo: updatedFarmerData,
        scheduleId: selectedScheduleId,
        createdBy: auth?.user?._id || JSON.parse(sessionStorage.getItem("user"))?._id || "",
      };

      const res = await createQuotation(quotationPayload);
      if (res) {
        console.log("Created quotation ", res);
        toast.success("Quotation created successfully");
      }

      setLoading(false);
      setAcreValues({});
      setFarmerInfo({
        name: "",
        place: "",
        tahsil: "",
        district: "",
        state: "",
        startDate: "",
      });
      const quotationId = res._id;

      navigate(`/schedule/quotation/${quotationId}`);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to generate quotation");
      fetchCrops();
    } finally {
      setLoading(false);
    }
  };

  // Load logged in user
  useEffect(() => {
    const loggedInUser = JSON.parse(sessionStorage.getItem("user"));

    if (loggedInUser) {
      // setUserData(loggedInUser);
      setFarmerInfo({
        _id: loggedInUser._id || "",
        name: loggedInUser.name || "",
        place: loggedInUser.place || "",
        tahsil: loggedInUser.tahsil || "",
        district: loggedInUser.district || "",
        state: loggedInUser.state || "",
        startDate: "",
      });
    }
  }, []);

  const promptFarmerDetails = () => {
    return new Promise((resolve) => {
      const name = prompt("Enter Farmer Name:");
      if (!name) return resolve(null);

      const place = prompt("Enter Place:");
      const tahsil = prompt("Enter Tahsil:");
      const district = prompt("Enter District:");
      const state = prompt("Enter State:");

      resolve({ name, place, tahsil, district, state });
    });
  };

  const [sortBy, setSortBy] = useState("createdAt"); // default sort by name

  const sortedCropList = [...cropList]
    .sort((a, b) => {
      if (sortBy === "name") return a.name.localeCompare(b.name);
      if (sortBy === "weeks") return a.weeks - b.weeks;
      if (sortBy === "createdAt") return new Date(b.createdAt) - new Date(a.createdAt);
      return 0;
    })
    .filter((crop) => crop.name.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="p-6 max-w-6xl mx-auto">
          {/* Page Header */}
          <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
            <h1 className="text-3xl font-bold text-green-800">Crop List</h1>

            <div className="flex flex-wrap items-center gap-3">
              {/* 🔍 Search Box */}
              <input
                type="text"
                placeholder="Search Crop Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border border-green-300 rounded-lg p-2 text-sm text-green-700 placeholder-green-400 focus:outline-none focus:ring-2 focus:ring-green-400"
              />

              {/* 🔽 Sort Dropdown */}
              <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="border border-green-300 rounded-lg p-2 text-sm text-green-700">
                <option value="name">Sort by Name</option>
                <option value="weeks">Sort by Weeks</option>
                <option value="createdAt">Sort by Date (Newest)</option>
              </select>
            </div>
          </div>

          {/* Crop List */}
          <div className="space-y-4">
            {sortedCropList.map((crop, index) => (
              <motion.div
                key={crop._id}
                className="bg-white border border-green-200 rounded-xl shadow-sm p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 hover:shadow-md transition"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                {/* Crop Info */}
                <div className="flex-1">
                  <div className="text-lg font-semibold text-green-900 hover:underline">
                    {crop.name} – {crop.weeks} weeks
                  </div>
                  {crop.description && <p className="text-sm text-gray-600 mt-1">{crop.description}</p>}
                </div>

                {/* Acres Input */}
                <input
                  type="number"
                  placeholder="Acres"
                  step="any"
                  className="border border-green-300 p-2 rounded-lg w-24 text-center focus:outline-none focus:ring-2 focus:ring-green-500"
                  value={acreValues[crop._id] || ""}
                  onChange={(e) =>
                    setAcreValues((prev) => ({
                      ...prev,
                      [crop._id]: e.target.value,
                    }))
                  }
                />

                <button
                  onClick={() => {
                    const acres = parseFloat(acreValues[crop._id]);
                    if (!acres || acres <= 0) {
                      toast.warning("कृपया 0 पेक्षा जास्त एकर प्रविष्ट करा!", {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        theme: "light",
                      });
                      return;
                    }
                    setShowModal(true);
                    setSelectedCropId(crop._id);
                    setSelectedScheduleId(crop.scheduleId);
                  }}
                  className="bg-green-100 text-green-700 hover:bg-green-200 p-2 rounded-full shadow"
                  title="Generate Quotation"
                >
                  <FaFileInvoice />
                </button>
              </motion.div>
            ))}
          </div>

          {/* Farmer Info Modal */}
          {showModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
              <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg space-y-3">
                <h2 className="text-lg font-semibold text-green-700">Enter Farmer Details</h2>

                {["name", "place", "tahsil", "district", "state"].map((field) => (
                  <input
                    key={field}
                    type="text"
                    name={field}
                    placeholder={`Enter ${field}`}
                    value={farmerInfo[field]}
                    onChange={(e) => setFarmerInfo({ ...farmerInfo, [field]: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-sm"
                  />
                ))}

                <label className="block mt-2 text-sm text-gray-700">Select Starting Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={farmerInfo.startDate}
                  onChange={(e) => setFarmerInfo({ ...farmerInfo, startDate: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-sm"
                />

                <div className="flex justify-end gap-3 pt-2">
                  <button onClick={() => setShowModal(false)} className="px-4 py-1.5 bg-gray-300 rounded hover:bg-gray-400 text-sm">
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      handleGenerateQuotation(selectedCropId, farmerInfo);
                      setShowModal(false);
                    }}
                    className="px-4 py-1.5 bg-green-600 text-white rounded hover:bg-green-700 text-sm"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default CropList;
